import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import type { DashboardPeriod, DashboardStats } from './dashboard.models';

@Injectable({ providedIn: 'root' })
export class DashboardApiService {
  private readonly http = inject(HttpClient);

  getStats(period: DashboardPeriod): Observable<DashboardStats> {
    return this.http.get<DashboardStats>(`${environment.apiUrl}/api/v1/dashboard/stats`, {
      params: { period },
      withCredentials: true,
    });
  }
}
